<template>
	<div class="policy">
		<div class="page-title">法律声明</div>
		<p class="policy-title">隐私政策</p>
		<p class="content-item">北门中文网非常重视您的隐私保护。您在使用我们的服务时，我们可能会收集和使用您的相关信息。我们希望通过本《隐私政策》向您说明，在使用我们的服务时，我们会如何收集、使用、储存和分享这些信息，以及我们将为您提供的访问、更新、控制和保护这些信息的方式。本《隐私政策》与您所使用的北门中文网服务息息相关，希望您仔细阅读，在需要时，按照本《隐私政策》的指引，作出您认为适当的选择。本《隐私政策》中涉及的相关技术词汇，我们尽量以简明扼要的表述，并提供进一步说明的链接，以便您的理解。 您使用或继续使用我们的服务，即意味着您理解、同意并接受我们按照本《隐私政策》收集、使用、储存和分享您的相关信息。 如对本《隐私政策》或相关事宜有任何问题和咨询，可致电网站客服电话010-82425430。</p>
		<p class="content-item list-main-title">1.可能收集的信息</p>
		<p class="content-item">我们提供服务时，可能会收集、储存和使用下列与您有关的信息。如果您不提供相关信息，可能无法注册成为我们的用户或无法享受我们提供的某些服务，或者无法达到相关服务拟达到的效果。</p>
		<p class="content-item">1.1 您提供的信息</p>
		<p class="content-item">您在注册账户、实名认证或使用我们的服务时，向我们提供的相关个人信息，包括但不限于例如：例如姓名、电话号码、电子邮件、联系地址、身份证号码、机构营业执照信息等（“个人信息”）；</p>
		<p class="content-item">您通过我们的服务向其他方提供的共享信息，以及您使用我们的服务时所储存的信息；</p>
		<p class="content-item">您使用我们的服务与家人和朋友分享内容、推荐作品，或邀请他人使用我们的服务时，您所提供的与上述人士有关的信息。</p>
		<p class="content-item">1.2 其他方分享的您的信息</p>
		<p class="content-item">其他方使用我们的服务时所提供有关您的共享信息或您上传北门中文网的作品信息、编剧信息和简介信息。</p>
		<p class="content-item">1.3 我们通过公开合法渠道获取的您的其他信息</p>
		<p class="content-item list-main-title">2. 如何使用信息</p>
		<p class="content-item">我们可能将在向您提供服务的过程之中所收集的信息用作下列用途：</p>
		<p class="content-item">2.1 向您提供服务；</p>
		<p class="content-item">2.2 在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性；</p>
		<p class="content-item">2.3 帮助我们创建、开发、运作、提供和改进我们的产品、服务、内容和宣传内容，并用于防止信息的丢失和泄露；</p>
		<p class="content-item">2.4 为了促进用户能更好地通过我们的产品、服务等达成交易；</p>
		<p class="content-item">2.5 使我们更加了解您如何接入和使用我们的服务，从而针对性地回应您的个性化需求，例如语言设定、位置设定、个性化的帮助服务和指示，或对您和其他用户作出其他方面的回应；</p>
		<p class="content-item">2.6评估我们服务中的作品推广活动的效果，并加以改善；</p>
		<p class="content-item">2.7向您发送与您相关的重要通知，例如关于服务的相关信息以及条款、条件和政策的变更，软件认证或管理软件升级；</p>
		<p class="content-item">2.8邀请您参与有关我们产品和服务的调查；</p>
		<p class="content-item">为了让您有更好的体验、改善我们的服务或您同意的其他用途，在符合相关法律法规的前提下，我们可能将通过某一项服务所收集的信息，以汇集信息或者个性化的方式，用于我们的其他服务。例如，在您使用我们的一项服务时所收集的信息，可能在另一服务中用于向您提供特定内容，或向您展示与您相关的、非普遍推送的信息。如果我们在相关服务中提供了相应选项，您也可以授权我们将该服务所提供和储存的信息用于我们的其他服务。</p>
		<p class="content-item list-main-title">3. 向第三方披露。</p>
		<p class="content-item">除以下情形外，未经您同意，我们以及我们的关联公司不会与任何第三方分享您的个人信息：</p>
		<p class="content-item">3.1我们以及我们的关联公司，可能将您的个人信息与我们的关联公司、合作伙伴及第三方服务供应商、承包商及代理（例如代表我们发出电子邮件或推送通知的通讯服务提供商、为我们提供位置数据的地图服务供应商）分享（他们可能并非位于您所在的法域），用作下列用途：</p>
		<p class="content-item">3.1.1 向您提供我们的服务；</p>
		<p class="content-item">3.1.2 实现“我们可能如何使用信息”部分所述目的；</p>
		<p class="content-item">3.1.3 履行我们在《北门中文网用户协议》或本《隐私政策》中的义务和行使我们的权利；</p>
		<p class="content-item">3.1.4 理解、维护和改善我们的服务。</p>
		<p class="content-item">3.2 随着我们业务的持续发展，我们以及我们的关联公司有可能进行合并、收购、资产转让或类似的交易，您的个人信息有可能作为此类交易的一部分而被转移。我们将在转移前通知您。</p>
		<p class="content-item">3.3 我们或我们的关联公司还可能为以下需要而保留、保存或披露您的个人信息:</p>
		<p class="content-item">3.3.1 遵守或执行适用相关的法律法规；</p>
		<p class="content-item">3.3.2 遵守法院命令或其他法律程序的规定及要求；</p>
		<p class="content-item">3.3.3 遵守相关政府机关的规定及要求；</p>
		<p class="content-item">3.3.4 为维护社会公共利益，或保护我们的客户、我们或我们的集团公司、其他用户或雇员的人身和财产安全或合法权益所合理必要的用途。</p>
		<p class="content-item list-main-title">4. 信息安全</p>
		<p class="content-item">我们仅在本《隐私政策》所述目的所必需的期间和法律法规要求的时限内保留您的个人信息。 我们使用各种安全技术和程序，以防信息的丢失、不当使用、未经授权阅览或披露。但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。</p>
		<p class="content-item">当您使用北门中文网的服务时，你上传的个人信息和内容会被其他用户看到，他们可能会阅读、收集或使用你的个人信息，他们也可能会将您的个人信息分享给北门中文网的其他用户。对于您决定在上述情形中分享或提交的个人信息，您应自行负责。例如，如果您在北门中文网平台发布的剧本、你您的个人信息，这些信息便是公开的。在使用此类功能时请多加小心自行做好甄选。</p>
		<p class="content-item">北门中文网也提供即时通讯功能，方便北门中文网的用户相互之间沟通交流，您通过北门中文网发送给其他用户的信息和内容可能会被他们收集或另作他用。对于您通过即时通讯功能分享给其他用户的信息，您应自行自主负责。如出现问题，北门中文网无法处理该等纠纷或承担任何举证责任。</p>
		<p class="content-item">因此，请您谨慎考虑通过我们的服务上传、发布和交流的信息内容。在一些情况下，您可通过我们某些服务的隐私设定来控制有权浏览您共享信息的用户范围。如要求从我们的服务中删除您的相关信息，请通过该等特别服务条款提供的方式操作。</p>
		<p class="content-item">编剧与编剧之间联系都需经过北门中文网平台商务进行联系，由北门中文网平台商务部门进行洽谈合作。</p>
		<p class="content-item list-main-title">5. 您分享的敏感个人信息</p>
		<p class="content-item">某些个人信息因其特殊性可能被认为是敏感个人信息，例如您的种族、宗教、个人健康和医疗信息等。相比其他个人信息，敏感个人信息受到更加严格的保护。</p>
		<p class="content-item">对于我们保留的个人信息，我们将为您提供适用于任何目的的访问权限，包括要求我们在数据不准确时予以纠正，或在依据法律或出于合法商业目的无权保留此等数据时予以删除。我们有权拒绝处理无实质意义/纠缠式的请求、损害他人隐私权的请求、极端不现实的请求，以及根据当地法律无需给予信息访问权的请求。</p>
		<p class="content-item">请注意，您在使用我们的服务时所提供、上传或发布的内容和信息（例如有关您社交活动的照片等信息），可能会泄露您的敏感个人信息。您需要谨慎地考虑，是否在使用我们的服务时披露相关敏感个人信息。</p>
		<p class="content-item">您使用或继续使用我们的服务，即意味着您理解、同意并愿意遵按守本《隐私政策》所述的目的和方式来处理您的敏感个人信息。</p>
		<p class="content-item list-main-title">6. 我们可能向您发送的邮件和信息</p>
		<p class="content-item">6.1邮件和信息推送</p>
		<p class="content-item">您在使用我们的服务时，我们可能使用您的信息向您的设备发送电子邮件、新闻或推送通知。如您不希望收到这些信息，可以按照我们的相关提示，在设备上选择取消订阅。</p>
		<p class="content-item">6.2 作品推送</p>
		<p class="content-item">我们可能使用您的相关信息，向您提供您可能更感兴趣的作品内容。</p>
		<p class="content-item">6.3 与服务有关的公告</p>
		<p class="content-item">我们可能在必要时（例如因系统维护而暂停某一项服务时）向您发出与服务有关的公告。您可能无法取消这些与服务有关、性质不属于推广的公告。</p>
		<p class="content-item">6.4 评论审核</p>
		<p class="content-item">您提交的评论中出现有违反国家法律法规规、政策规定、平台公共要求或辱骂、造谣等有违社会公序良俗国家、平台、辱骂、等以及其他违背平台协议的语句时，平台可进行删除或修改状态不在前台展示您的评论，如违法或其他严重情况下可暂停您的用户评论权限。在此也提醒所有用户，遵循互联网信息的相关法律法规，共同维护平台的公共利益。您使用或继续使用我们的服务，即意味着您理解、同意并愿意遵守本《隐私政策》所述的要求和方式来使用评论功能。</p>
		<p class="content-item list-main-title">7. 隐私政策的适用范围</p>
		<p class="content-item">我们的服务可能包括或链接至第三方提供的社交媒体或其他服务（包括网站）。例如：</p>
		<p class="content-item">7.1 您利用 “分享”键将我们的服务或某些内容分享，或您利用第三方连线服务登录我们的服务。这些功能可能会收集您的相关信息（包括您的日志信息），并可能在您的电脑装置cookies，从而正常运行上述功能；</p>
		<p class="content-item">7.2 我们在北门中文网平台上提供合作伙伴的链接，使您可以接入第三方的服务或网站。</p>
		<p class="content-item">本《隐私政策》仅适用于我们所收集的信息，并不适用于任何第三方提供的服务或第三方的信息使用规则，我们对任何第三方使用由您提供的信息不承担任何责任。</p>
		<p class="content-item">该等第三方社交媒体或其他服务可能由相关的第三方或我们运营。您使用该等第三方的社交媒体服务或其他服务（包括您向该等第三方提供的任何个人信息），须受该第三方的服务条款及隐私政策（而非《通用服务条款》或本《隐私政策》）约束，您需要仔细阅读其条款。</p>
		<p class="content-item list-main-title">8. 隐私政策变更我们可能适时修订本《隐私政策》的条款，该等修订构成本《隐私政策》的一部分。如该等修订造成您在本《隐私政策》下权利的实质减少，我们将在修订生效前通过在主页上显著位置提示或向您发送电子邮件或以其他方式通知您。在该种情况下，若您继续使用我们的服务，即表示同意受经修订的本《隐私政策》的约束。</p>
	</div>
</template>

<script>
export default {
	name:'Policy'
}
</script>

<style scoped lang="scss">
.policy{
	padding:150px 46px 60px 46px;
	.page-title{
		color:#222;
		font-size:30px;
		font-weight:bold;
		margin-bottom:52px;
	}
	.policy-title{
		color:#535353;
		font-weight:bold;
		font-size:24px;
		margin-bottom:36px;
	}
	.content-item{
		font-size:22px;
		color:#999;
		line-height:36px;
		margin-bottom:36px;
	}
	.list-main-title{
		color:#333;
	}
}
</style>